import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import SQLForm from './form';

function SQLModal(props) {
  const {
    shown, t, query,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [query, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  return (
    <Modal size="xl" isOpen={modalOpen}>
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="sqlModalLabel"
        >
          {query?.id ? t('Edit SQL Query') : t('Create SQL Query')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); props.onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <SQLForm entity={query} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); props.onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="SQLForm"
          className="btn btn-primary"
        >
          {t('Save Changes')}
        </button>
      </div>
    </Modal>
  );
}

SQLModal.defaultProps = {
  t: (x) => (x),
  shown: false,
  query: {},
  onSuccess: () => {},
  onClose: () => {},
};

SQLModal.propTypes = {
  t: PropTypes.any,
  query: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(SQLModal));
